import React from 'react';
import WithSpiner from '../with-spiner/with-spiner.component';
import {Link} from 'react-router-dom';
import './RegisterPage.style.scss';
import firebase from '../firebase/firebase.utils';


class Register extends React.Component{
    constructor(props){
        super(props);
        this.state={
          UPUTSTVO:[],
        };
      };
    
    
    componentDidMount(){
      const uputstvoRef=firebase.database().ref('UPUTSTVO');
      uputstvoRef.on('value',(snapshot)=>{
        let UPUTSTVO=snapshot.val();
        let newState=[];
        for (let mail  in UPUTSTVO){
          newState.push({
            id:mail,
           mail:UPUTSTVO[mail].mail,
            telefon:UPUTSTVO[mail].telefon,
            osoba:UPUTSTVO[mail].osoba,
            cena1:UPUTSTVO[mail].cena1,
            cena2:UPUTSTVO[mail].cena2
          });
        }
        this.setState({
          UPUTSTVO:newState
        });
      });
      setTimeout(() => { 
        this.setState({loading: true})
      },2200)
    }

    componentWillUnmount = () => {
      this.setState({loading:undefined})
    }

    render(){
      
      return(
        <div>
        {this.state.loading ?(
          <Link className='back-button' to='/' > &#8249;&#8249; НАЗАД НА ПОЧЕТНУ</Link>
   ):(null)
        }
    <div className='register-container'>
  
    {
      this.state.UPUTSTVO.map((mail)=>{
        return(<div key={mail.mail} >
          { this.state.loading ? (   
            <div className='register-component' >
<h2>Упутство за регистрацију</h2>

<p>
Обавештавамо будуће полазнике да прелазимо на онлајн релиценцирање за ДДД послове и послове
ФУМИГАЦИЈЕ.

Овај начин обнављања лиценци биће лакши, једноставнији и повољнији, а у времену пандемија и безбеднији за све полазнике.
</p><p>Пријављивање заинтересованих може се  обавити путем маила на {mail.mail} или телефоном на број
_{mail.telefon}.</p>
<ul>
    <li>Након пријаве добићете профактуру на износ за лиценцирање и то:</li>
    <li>– {mail.cena1} динара - релиценца из ДДД послова</li>
    <li>– {mail.cena2} динара - релиценца из фумигације</li>
</ul>
<p>
Након уплате износа, мејлом ће вам бити прослеђено корисничко име и шифра за приступ тесту као и упутство за онлине релиценцирање.
</p>
<p>
Пре него што почнете да решавате тест, прочитајте литературу везанu за ту тему јер ће и питања бити формулисана на основу података из приложеног текста.
</p>
<p>
Након успешног решавања теста, потврда о релиценцирању ће бити послата поштом на адресу фирме.
</p>

<p>WЕБ презентација је погодна за све типове уређаја -  десктоп и лаптоп рачунаре  са Wиндоwс, МАК и Линуx оперативним системом  укључујући и мобилне телефоне са Андроид и ИОС платформом.</p>



</div> ) : (
  <WithSpiner />
   )}
</div>
 );
   })
    }
    </div></div>
   
      );
    }
    
    }
    

export default Register;